import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as fromUser from '@app/core/user/store/reducers';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { LikeTypes } from '@app/shared/components/like/like-types.enum';
import { Subscription } from 'rxjs';
import { Product, Negotiation, ProductReservation, User } from '@vestiaire/api-sdk-angular';
import { Discussions, IDiscussionModalData } from '@app/shared/components/discussions/discussion';

@Component({
  selector: 'vc-discussions-modal',
  templateUrl: './discussions-modal.component.html',
  styleUrls: ['./discussions-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiscussionsModalComponent extends Discussions implements OnInit, AfterViewInit, OnDestroy {
  @Output()
  sendMessage: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('discussionsMessages', {
    read: ElementRef,
    static: false
  })
  discussionsMessages: ElementRef;

  @ViewChild('discussionsModal', {
    static: false
  })
  discussionsModal: ElementRef;

  public allComments: any;
  public nbDiscussions = 0;
  public isAuthenticated: boolean;
  public commentType: string;
  public translateAll = false;
  public likedItem = [];
  public subscriptions: Subscription;
  public product: Product;
  public negotiations: Negotiation[];
  public reservation: ProductReservation;
  public user: User;
  public editoId: string;
  public showLikeFunctionality: boolean;
  public showListContainerBorder = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDiscussionModalData,
    private store: Store<IAppState>,
    private changeDetection: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.allComments = this.data.allComments;
    this.nbDiscussions = this.allComments.length;
    this.isAuthenticated = this.data.isAuthenticated;
    this.commentType = this.data.commentType;
    this.product = this.data.product;
    this.negotiations = this.data.negotiations;
    this.reservation = this.data.reservation;
    this.user = this.data.user;
    this.editoId = this.data.editoId;
    this.showLikeFunctionality = this.data.showLikeFunctionality;

    this.subscriptions = this.store.pipe(select(fromUser.getLikedItems)).subscribe(
      likedItems => {
        if (!likedItems) {
          return;
        }
        this.likedItem = likedItems[LikeTypes.COMMENTS];
      },
      error => {
        console.log(error);
      }
    );
  }

  ngAfterViewInit() {
    this.scrollToBottom();
    this.applyListContainerHeight();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  addContainerMargin(value) {
    if (this.discussionsMessages) {
      this.discussionsMessages.nativeElement.style.marginBottom = value + 'px';
    }
  }

  addNewComment(event) {
    if (event.message) {
      this.sendMessage.emit(event);
    }
  }

  toggleTranslateAll() {
    this.translateAll = !this.translateAll;
  }

  scrollToBottom() {
    if (this.discussionsMessages) {
      this.discussionsModal.nativeElement.scrollTop += this.discussionsMessages.nativeElement.offsetHeight;
    }
  }

  applyListContainerHeight() {
    if (this.discussionsMessages) {
      this.showListContainerBorder =
        this.discussionsMessages.nativeElement.offsetHeight > this.discussionsModal.nativeElement.offsetHeight;
    }
    this.changeDetection.detectChanges();
  }
}
